import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { Registry } from 'vscode/vscode/vs/platform/registry/common/platform';
import { Extensions } from 'vscode/vscode/vs/platform/jsonschemas/common/jsonContributionRegistry';
import { iconsSchemaId } from 'vscode/vscode/vs/platform/theme/common/iconRegistry';

const _moduleId = "vs/workbench/services/themes/common/productIconThemeSchema";
const fontIdRegex = '^([\\w_-]+)$';
const fontStyleRegex = '^(normal|italic|(oblique[ \\w\\s-]+))$';
const fontWeightRegex = '^(normal|bold|lighter|bolder|(\\d{0-1000}))$';
const fontSizeRegex = '^([\\w .%_-]+)$';
const fontFormatRegex = '^woff|woff2|truetype|opentype|embedded-opentype|svg$';
const schemaId = 'vscode://schemas/product-icon-theme';
const schema = {
    type: 'object',
    allowComments: true,
    allowTrailingCommas: true,
    properties: {
        fonts: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string',
                        description: ( localizeWithPath(_moduleId, 0, 'The ID of the font.')),
                        pattern: fontIdRegex,
                        patternErrorMessage: ( localizeWithPath(
                            _moduleId,
                            1,
                            'The ID must only contain letters, numbers, underscore and minus.'
                        ))
                    },
                    src: {
                        type: 'array',
                        description: ( localizeWithPath(_moduleId, 2, 'The location of the font.')),
                        items: {
                            type: 'object',
                            properties: {
                                path: {
                                    type: 'string',
                                    description: ( localizeWithPath(
                                        _moduleId,
                                        3,
                                        'The font path, relative to the current product icon theme file.'
                                    )),
                                },
                                format: {
                                    type: 'string',
                                    description: ( localizeWithPath(_moduleId, 4, 'The format of the font.')),
                                    enum: ['woff', 'woff2', 'truetype', 'opentype', 'embedded-opentype', 'svg']
                                }
                            },
                            required: [
                                'path',
                                'format'
                            ]
                        }
                    },
                    weight: {
                        type: 'string',
                        description: ( localizeWithPath(
                            _moduleId,
                            5,
                            'The weight of the font. See https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight for valid values.'
                        )),
                        anyOf: [
                            { enum: ['normal', 'bold', 'lighter', 'bolder'] },
                            { type: 'string', pattern: fontWeightRegex }
                        ]
                    },
                    style: {
                        type: 'string',
                        description: ( localizeWithPath(
                            _moduleId,
                            6,
                            'The style of the font. See https://developer.mozilla.org/en-US/docs/Web/CSS/font-style for valid values.'
                        )),
                        anyOf: [
                            { enum: ['normal', 'italic', 'oblique'] },
                            { type: 'string', pattern: fontStyleRegex }
                        ]
                    }
                },
                required: [
                    'id',
                    'src'
                ]
            }
        },
        iconDefinitions: {
            description: ( localizeWithPath(_moduleId, 7, 'Association of icon name to a font character.')),
            $ref: iconsSchemaId
        }
    }
};
function registerProductIconThemeSchemas() {
    const schemaRegistry = ( (Registry.as(Extensions.JSONContribution)));
    schemaRegistry.registerSchema(schemaId, schema);
}

export { fontFormatRegex, fontIdRegex, fontSizeRegex, fontStyleRegex, fontWeightRegex, registerProductIconThemeSchemas };
